<template>
  <el-select
    v-if="show"
    ref="select"
    :value="_value"
    filterable
    :allow-create="canInputCustom"
    placeholder="请选择"
    :remote="isAsyncOptions"
    :loading="isAsyncOptions ? loading : false"
    :remote-method="remoteMethod"
    :nameKey="nameKey"
    v-bind="props"
    clearable
    @input="onChange"
    @focus="handleFocus">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item[nameKey]"
      :value="item"
    >
    </el-option>
  </el-select>
</template>

<script>
import storeMixins from '../store-mixins'
import _ from 'lodash'
export default {
  mixins: [storeMixins],
  props: ['props', 'value', 'isMultiComlexItem'],
  data() {
    return {
      isHasOptionsComp: true,
      loading: false,
      show: true
    }
  },
  computed: {
    // options() {
    //   return this.props.dataSource.options;
    // },
    key() {
      return this.props.name
    },
    _value() {
      if (this.isMultiComlexItem) {
        return this.value
      }

      if (this.props.vk) {
        return this.tjbForm[this.key][this.props.vk]
      } else {
        return this.tjbForm[this.key]
      }
    },
    nameKey() {
      return this.props.displayName || 'displayName'
    },
    canInputCustom() {
      return this.props.canInputCustom
    }
  },
  watch: {
    options: {
      handler(options) {
        if (this.canInputCustom) {
          let hasValue = options ? options.some(item => {
            if (!this._value) return false
            return item.value === this._value.value
          }) : false
          !hasValue && this.onChange('')
        } else {
          if (!(this._value instanceof Object)) {
            let op = options.find(op => op.value == this._value)
            if (op) {
              this.onChange(op)
            } else {
              this.onChange('')
            }
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    onChange(v) {
      if (this.isMultiComlexItem) {
        return this.$emit('change', v.value)
      }


      if (v && typeof v === 'string' && this.canInputCustom) {
        // 若是可自定义输入的选择框，则需要对其进行改造
        // 取一个模板
        let copy = _.cloneDeep(this.options[0])
        copy.displayName = v
        copy.value = window._tjb_cutomId-- + ''
        v = copy
      }

      const newFormFields = {}
      if (this.props.vk) {
        newFormFields[this.key] = [v]
      } else {
        newFormFields[this.key] = v
      }
      this.updateTjbForm(newFormFields)
    },
    handleFocus() {
      this.remoteMethod()
    },
    async remoteMethod(query = '') {
      this.loading = true
      // 目前先前端搜索分页
      // 后续看后端是否支持，则要调用后端借口
      let options = this.tjbOptions({key: this.key, search: query})
      if (!options) return ;
      this.options = options
      this.loading = false

    }
  }
};
</script>